
const VERSION = {
  SHA1:'1a9ab8ef57cd874fbdc0621d021fdfef22c5d0dd',
  VERSION:2300,
  BRANCH:'main',
  PROJECT:'ostium-ne'
}
export default VERSION;
